import React, { forwardRef } from 'react';

import { ArrowDownIcon } from '@depop/web-ui-kit/Icons/ArrowDownIcon';
import { clsx, type ClassValue } from 'clsx';

import styles from './styles.module.css';

export type SelectChangeEvent<T> = React.ChangeEvent<HTMLSelectElement> & {
  target: {
    value: T;
  };
};

export type CustomStyles = {
  '--width'?: string;
};

type SelectProps = React.SelectHTMLAttributes<HTMLSelectElement> & {
  children: React.ReactNode;
  label?: string;
  onChange?: (e: SelectChangeEvent<never>) => void;
  small?: boolean;
  testId?: string;
  className?: string;
  style?: React.SelectHTMLAttributes<HTMLDivElement>['style'] & CustomStyles;
};

export const Select = forwardRef<HTMLDivElement, SelectProps>(function Select(
  { children, small, testId, className, style, label, ...selectAttrs },
  ref
) {
  const conditionalStyles: ClassValue = {
    [styles['selectContainer--sm']]: small,
  };
  return (
    <div
      className={clsx(styles.selectContainer, conditionalStyles, className)}
      ref={ref}
      style={style}
    >
      <select
        {...selectAttrs}
        aria-label={label ?? selectAttrs['aria-label']}
        // eslint-disable-next-line no-restricted-syntax
        data-testid={testId}
      >
        {children}
      </select>
      <ArrowDownIcon title="Open" />
    </div>
  );
});
